import PropTypes from "prop-types";
import styles from "./Alert.module.scss";

export default function Alert({ children }) {
  return (
    <div role="alert" className={styles.alert}>
      {children}
    </div>
  );
}

Alert.propTypes = {
  children: PropTypes.node.isRequired,
};
